"use strict";
/**
 * @file Created on 08.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NSimDummyProductConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NSimDummyProductConverter, _NotificationDocConve);

  function NSimDummyProductConverter() {
    _classCallCheck(this, NSimDummyProductConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NSimDummyProductConverter).apply(this, arguments));
  }

  return NSimDummyProductConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NSimDummyProductConverter = NSimDummyProductConverter;